import { useTheme } from '@mui/material';

/**
 * Custom hook to check if dark theme is enabled
 * @param {Object} customDetails - Custom theme details from props
 * @returns {boolean} - True if dark theme is enabled
 */
export const useDarkTheme = (customDetails) => {
  const theme = useTheme();
  return customDetails?.darkTheme === true || theme.palette.mode === 'dark';
};

/**
 * Get dark theme colors
 * @returns {Object} - Object containing dark theme color values
 */
export const getDarkThemeColors = () => ({
  background: {
    primary: '#161616',
    secondary: '#1E1E1E',
    tertiary: '#2D2D2D',
    surface: '#161616',
  },
  text: {
    primary: '#FFFFFF',
    secondary: '#7A8185',
    tertiary: '#A5AAB8',
  },
  border: {
    primary: '#161616',
    secondary: '#7A8185',
  },
  button: {
    background: '#FFFFFF',
    text: '#000000',
    hover: '#F5F5F5',
  }
});
